import React from 'react';
import { ArrayHelpers, Paging, ProgressBar, StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import BlobImage from 'components/blobImage';
import { Link } from 'react-router-dom';
import { quotaColour } from 'helpers/metrics';
import { useSelector } from 'react-redux';
import posthog from 'posthog-js';

const Chart = ({ data, metric, item, id }) => {
    const loaded = React.useRef(null);
    const [pagedData, setPagedData] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(6);
    const recordCount = data.length;

    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        const pageSizeGenerator = () => {
            const rowHeight = 63;
            const extrasHeight = 20;
            const me = document.querySelector(`#${id}`);
            let result = me ? Math.floor((me.offsetHeight - extrasHeight) / rowHeight) : 10;
            return result < 0 ? 0 : result;
        };

        const ps = pageSizeGenerator();

        setPagedData(ArrayHelpers.getPage(data, page, ps));
        setPageSize(ps);
    }, [id, page, data, item.h]);

    React.useEffect(() => {
        setPage(1);
    }, [item.h]);

    return (
        <div ref={loaded} className="performance-data">
            {pagedData.map((s, i) => {
                const target = s.quota;
                const actual = s.value;
                const percent = target ? ((actual / target) * 100).toFixed() : 0;
                return (
                    <div key={`data-${i}-staff-${s.id}`} className="flex mb10 flex-center">
                        <Link
                            onClick={() => posthog.capture('widget-profile-click')}
                            to={`/develop/performance-dashboard/${s.id}`}
                        >
                            <BlobImage
                                height="30"
                                className="img-square mr5"
                                src={s.avatar}
                                folder="avatar"
                                initials={s.initials}
                                alt={s.full_Name}
                            />
                        </Link>
                        <span
                            className="flex-grow"
                            title={`${SystemText('Dashboard/Widgets/GoalsAchieved/Currently')} ${StringHelpers.formatMetric(
                                metric.format,
                                actual,
                                user.currencySymbol
                            )} ${SystemText('Dashboard/Widgets/GoalsAchieved/Target')} ${StringHelpers.formatMetric(
                                metric.format,
                                target,
                                user.currencySymbol
                            )}`}
                        >
                            <ProgressBar
                                small
                                progress={percent}
                                colour={quotaColour(percent)}
                                value={`${s.full_Name} - ${percent}%`}
                                title="&nbsp;"
                            />
                        </span>
                    </div>
                );
            })}
            {recordCount > pageSize && (
                <div className="text-center mt10">
                    <Paging
                        page={page}
                        narrow={item.w < 3}
                        pageSize={pageSize}
                        recordCount={recordCount}
                        goToPage={setPage}
                    />
                </div>
            )}
        </div>
    );
};

export default Chart;
